module.exports = __webpack_public_path__ + "img/payment_success.43e85647.png";